import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function ContactPage() {
  return <div className="bg-black min-h-screen" data-id="element-359">
      <Navigation data-id="element-360" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-361">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-362">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-363">
            Get in <span className="text-[#00D4FF]" data-id="element-364">Touch</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-365">
            Have questions? We're here to help. Reach out to us or stop by for a
            visit.
          </p>
        </motion.div>
      </div>

      <section className="py-12 bg-[#111]" data-id="element-366">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-367">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-368">
            {/* Contact Info */}
            <div className="space-y-12" data-id="element-369">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-370">
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-371">
                  <MapPin className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-372" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-373">
                    Visit Us
                  </h3>
                  <p className="text-gray-400" data-id="element-374">
                    123 Martial Arts Way
                    <br data-id="element-375" />
                    Bloomington, IL 61704
                  </p>
                </div>
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-376">
                  <Phone className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-377" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-378">Call Us</h3>
                  <p className="text-gray-400" data-id="element-379">(309) 555-0123</p>
                </div>
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-380">
                  <Mail className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-381" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-382">
                    Email Us
                  </h3>
                  <p className="text-gray-400" data-id="element-383">info@walkersmartialarts.com</p>
                </div>
                <div className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-384">
                  <Clock className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-385" />
                  <h3 className="text-white font-bold text-lg mb-2" data-id="element-386">Hours</h3>
                  <p className="text-gray-400" data-id="element-387">
                    Mon-Fri: 3pm - 9pm
                    <br data-id="element-388" />
                    Sat: 9am - 2pm
                  </p>
                </div>
              </div>

              {/* Map Placeholder */}
              <div className="w-full h-64 bg-gray-800 rounded-2xl overflow-hidden relative" data-id="element-389">
                <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2074&auto=format&fit=crop" alt="Map location" className="w-full h-full object-cover opacity-50" data-id="element-390" />
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-391">
                  <span className="bg-black/80 text-white px-4 py-2 rounded-lg backdrop-blur-sm" data-id="element-392">
                    Interactive Map Loading...
                  </span>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-393">
              <h2 className="text-2xl font-bold text-white mb-6" data-id="element-394">
                Send a Message
              </h2>
              <form className="space-y-6" data-id="element-395">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-396">
                  <div data-id="element-397">
                    <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-398">
                      First Name
                    </label>
                    <input type="text" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="John" data-id="element-399" />
                  </div>
                  <div data-id="element-400">
                    <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-401">
                      Last Name
                    </label>
                    <input type="text" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="Doe" data-id="element-402" />
                  </div>
                </div>

                <div data-id="element-403">
                  <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-404">
                    Email Address
                  </label>
                  <input type="email" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="john@example.com" data-id="element-405" />
                </div>

                <div data-id="element-406">
                  <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-407">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="(555) 123-4567" data-id="element-408" />
                </div>

                <div data-id="element-409">
                  <label className="block text-sm font-medium text-gray-400 mb-2" data-id="element-410">
                    Message
                  </label>
                  <textarea rows={4} className="w-full bg-black border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-[#00D4FF] transition-colors" placeholder="How can we help you?" data-id="element-411" />
                </div>

                <button type="submit" className="w-full bg-[#00D4FF] text-black font-bold uppercase tracking-wider py-4 rounded-lg hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-412">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-413" />
    </div>;
}